import React from 'react';

import { NavigationLayout } from 'design/navigationLayout';
import { NavigationGroupLayout } from 'design/navigationGroupLayout';
import { NavigationLinksLayout } from 'design/navigationLinksLayout';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { routes } from 'utils/routes';
import { LogoComponent } from 'design/logo';
import { ThemeProviderComponent } from 'design/themeProvider';
import { TextComponent } from 'design/text/textComponents';
import { LinkControlComponent } from 'design/linkControl';
import { useAppState } from 'hooks/useAppState';

export const AdminNavigation = () => {
  const { adminNavigation } = useIntlDictionary();

  const { environment } = useAppState();

  return (
    <ThemeProviderComponent
      mode={
        environment.value === 'production'
          ? 'adminNavigationProd'
          : 'adminNavigationTesting'
      }
    >
      <NavigationLayout
        logoNode={
          <TextComponent family="futura">
            <LogoComponent
              theme="admin"
              subTitle={adminNavigation.logoHintText}
            />
          </TextComponent>
        }
        primaryNode={
          <>
            <NavigationGroupLayout
              titleNode={
                <TextComponent color="secondary" upperCase>
                  {adminNavigation.clientsGroupText}
                </TextComponent>
              }
              linksNode={
                <NavigationLinksLayout>
                  <LinkControlComponent navigation to={routes.clientsRoot()}>
                    <TextComponent color="primary">
                      {adminNavigation.actualClientsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                  <LinkControlComponent navigation to={routes.archiveRoot()}>
                    <TextComponent color="primary">
                      {adminNavigation.archiveClientsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                </NavigationLinksLayout>
              }
            />
            <NavigationGroupLayout
              titleNode={
                <TextComponent color="secondary" upperCase>
                  {adminNavigation.productsGroupText}
                </TextComponent>
              }
              linksNode={
                <NavigationLinksLayout>
                  <LinkControlComponent navigation to={routes.products()}>
                    <TextComponent color="primary">
                      {adminNavigation.productsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                  <LinkControlComponent navigation to={routes.promocodes()}>
                    <TextComponent color="primary">
                      {adminNavigation.promocodesLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                </NavigationLinksLayout>
              }
            />
            <NavigationGroupLayout
              titleNode={
                <TextComponent color="secondary" upperCase>
                  {adminNavigation.paymentsGroupText}
                </TextComponent>
              }
              linksNode={
                <NavigationLinksLayout>
                  <LinkControlComponent navigation to={routes.billsRoot()}>
                    <TextComponent color="primary">
                      {adminNavigation.billsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                  <LinkControlComponent
                    navigation
                    to={routes.cardPaymentsRoot()}
                  >
                    <TextComponent color="primary">
                      {adminNavigation.cardPaymentsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                  <LinkControlComponent
                    navigation
                    to={routes.giroPaymentsRoot()}
                  >
                    <TextComponent color="primary">
                      {adminNavigation.giroPaymentsLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                </NavigationLinksLayout>
              }
            />
            <NavigationGroupLayout
              titleNode={
                <TextComponent color="secondary" upperCase>
                  {adminNavigation.partnersGroupText}
                </TextComponent>
              }
              linksNode={
                <NavigationLinksLayout>
                  <LinkControlComponent navigation to={routes.partnersRoot()}>
                    <TextComponent color="primary">
                      {adminNavigation.actualPartnersLinkText}
                    </TextComponent>
                  </LinkControlComponent>
                </NavigationLinksLayout>
              }
            />
          </>
        }
        secondaryNode={
          <NavigationLinksLayout>
            <LinkControlComponent navigation to={routes.dashboard()}>
              <TextComponent color="primary">
                {adminNavigation.dashboardLinkText}
              </TextComponent>
            </LinkControlComponent>
            <LinkControlComponent local to={routes.signOut()}>
              <TextComponent color="primary">
                {adminNavigation.logoutLinkText}
              </TextComponent>
            </LinkControlComponent>
          </NavigationLinksLayout>
        }
      />
    </ThemeProviderComponent>
  );
};
